import React from "react";
import AppBody from "../components/AppBody";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  deleteBankDetails,
  getAllBankDetails,
} from "../../actions/trainer/bank_details_action";
import { ToastContainer, toast } from "react-toastify";

const TrainerBankDetailsList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const state = useSelector((state) => state.bankDetailsReducer);

  useEffect(() => {
    dispatch(getAllBankDetails());
  }, []);

  const editBankDetails = (id) => {
    navigate("/trainer/update-bank-details/" + window.btoa(id));
  };

  const deleteBank = (id) => {
    dispatch(deleteBankDetails({ id: id }));
  };

  if (state.is_done) {
    toast("Record deleted successfully!", {
      type: "success",
      position: "top-center",
    });
    dispatch(getAllBankDetails());
    //navigate("/trainer/bank-details-list");
  }
  return (
    <AppBody
      loading={state.loading}
      content={
        <div className="middle-sidebar-left">
          <div className="card w-100 border-0  shadow-xs p-0 mb-4">
            <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
              <Link to={"/"} className="d-inline-block mt-2">
                <i className="ti-arrow-left font-sm text-white"></i>
              </Link>
              <h4 className="font-xs text-white fw-600 ml-4 mb-0 mt-2">
                Bank Details List
              </h4>
              <div className="col text-right pr-0">
                <Link to={"/trainer/add-bank-details"}>
                  <a
                    className="line-height-36 custom-icon mr-2"
                    title="Trainer Register"
                  >
                    <i className="feather-plus-circle"></i>
                  </a>
                </Link>
              </div>
            </div>
            <ToastContainer />
            <div className="card-body  p-4 w-100 border-0 ">
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr.No</th>
                      <th>Bank Name</th>
                      <th>Bank Address</th>
                      <th>Name</th>
                      <th>Account No</th>
                      <th>Account Type</th>
                      <th>IFSC Code</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {state.list &&
                      state.list.map((li, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{li.bank_name}</td>
                          <td>{li.bank_address}</td>
                          <td>{li.bank_account_name}</td>
                          <td>{li.account_number}</td>
                          <td>{li.account_type}</td>
                          <td>{li.ifsc_code}</td>
                          <td>
                            <a
                              className="line-height-36 custom-icon mr-2"
                              title="Update"
                              target="_blank"
                              onClick={() => editBankDetails(li.id)}
                            >
                              <i className="feather-edit"></i>
                            </a>
                            <a
                              className="line-height-36 custom-icon mr-2"
                              title="Update"
                              target="_blank"
                              onClick={() => deleteBank(li.id)}
                            >
                              <i className="feather-trash"></i>
                            </a>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default TrainerBankDetailsList;
